export class CostReviewAirHandlers {
  numberOfAirHandlerUnits!: number;
  manufacturer!: string;
  unitsControlsFurnishedBy!: number;
  unitsControlsInstalledBy!: number;
  unitsControlsWiredBy!: number;
  specialSensorsRequired!: number;
  isAirHandlersApplicable!: boolean;
  numberOfFans!: number | null;
  description!: string;
}
